import React from 'react'

import { TextStyle } from 'component-library-next'

import { ISelectedEmailTemplate } from '@app/modules/Messages/Components/AnswerArea/AnswerArea'

import './styles.scss'

interface IEmailTemplatePreview {
  emailTemplate: ISelectedEmailTemplate
  onClose: () => void
}

export const EmailTemplatePreview = (props: IEmailTemplatePreview) => {
  const { emailTemplate, onClose } = props
  return (
    <div>
      <div className='emailTemplatePreview__text'>
        <TextStyle size={TextStyle.sizes.small}>
          Die Mandanten können die Vorlage im Portal online anpassen und dort versenden oder als
          offene Datei herunterladen. Die Vorlage für eine Kündigung enthält nach dem Download noch
          einen Briefkopf zum Versenden per Post.
        </TextStyle>
      </div>
      <div className='emailTemplatePreview__content'>
        <textarea
          className='emailTemplatePreview__textArea'
          name='emailTemplatePreview'
          disabled
          value={emailTemplate.content}
        ></textarea>
        <div className='emailTemplatePreview__button'>
          <span onClick={onClose}>LÖSCHEN</span>
        </div>
      </div>
    </div>
  )
}
